import * as React from "react";
import "highlight.js/styles/base16/harmonic16-dark.css";
import {Button, Icon} from "bloomer";
import {toast} from "react-toastify";
import Spacer from "../../../elements/Spacer";
import styled from "react-emotion";

const CodeExampleTitle = styled("div")`
  text-align: left;
  font-size: 16px;
  font-weight: bold;
`;

interface ICodeExampleProps {
    title: string;
    modelName: string;
    language: string;
    codeClass: string;
    inputCode: string;
    outputCode: string;
    usageCode: string;
}

interface ICodeExampleState {
    loading: boolean;
    title: string;
}

class CodeExample extends React.Component<ICodeExampleProps, ICodeExampleState> {

    constructor(props: ICodeExampleProps) {
        super(props);

        let title = props.title || "";
        if (title) {
            title = title.split("/").reverse()[0];
        }

        this.state = {
            loading: false,
            title
        };
    }

    public copyToClipboard = (text: string) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        document.execCommand('copy');
        document.body.removeChild(textarea);

        toast.success("Copied to clipboard!");
    };

    public render() {
        if (this.state.loading) {
            return <React.Fragment>
                <CodeExampleTitle>{this.state.title}:</CodeExampleTitle>
                <Spacer/>
                <div style={{textAlign: 'center'}}>
                    <span>Loading...</span>
                    <Icon className="fas fa-spinner fa-spin"/>
                </div>
            </React.Fragment>;
        }

        if (!this.props.inputCode || !this.props.outputCode || !this.props.usageCode) {
            return <React.Fragment>
                <CodeExampleTitle>{this.state.title}:</CodeExampleTitle>
                <Spacer/>
                <div style={{textAlign: 'center'}}>
                    <span>{this.props.language}{" API code examples couldn't be loaded for this model at the moment. Please try again later."}</span>
                </div>
            </React.Fragment>;
        }

        return <div style={{maxWidth: '400px'}}>
            <CodeExampleTitle>{this.state.title}:</CodeExampleTitle>
            <Spacer/>
            <div style={{
                display: 'flex'
            }}>
                <div style={{
                    flex: 1,
                    marginRight: '10px',
                }}>
                    <div>Input:</div>
                    <div style={{position: 'relative', width: '390px'}}>
                        <pre style={{width: '390px', padding: 0}}>
                            <code style={{height: '180px', overflow: 'auto', padding: '50px 20px 20px 20px'}}
                                  className="language-json">
                                {this.props.inputCode}
                            </code>
                        </pre>
                        {
                            this.props.inputCode ? <Button
                                style={{
                                    fontSize: '14px',
                                    color: 'white',
                                    backgroundColor: '#0b1c2c',
                                    border: 0,
                                    position: 'absolute', top: '10px', right: '25px'
                                }}
                                onClick={(e: any) => {
                                    e.target.blur();
                                    this.copyToClipboard(this.props.inputCode);
                                }}
                            ><Icon className="far fa-copy" style={{marginRight: '5px'}}/>Copy</Button> : <></>
                        }
                    </div>
                </div>
                <div style={{
                    flex: 1,
                    marginLeft: '10px'
                }}>
                    <div>Output:</div>
                    <div style={{position: 'relative', width: '390px'}}>
                        <pre style={{width: '390px', padding: 0}}>
                            <code style={{height: '180px', overflow: 'auto', padding: '50px 20px 20px 20px'}}
                                  className="language-json">
                                {this.props.outputCode}
                            </code>
                        </pre>
                        {
                            this.props.outputCode ? <Button
                                style={{
                                    fontSize: '14px',
                                    color: 'white',
                                    backgroundColor: '#0b1c2c',
                                    border: 0,
                                    position: 'absolute', top: '10px', right: '25px'
                                }}
                                onClick={(e: any) => {
                                    e.target.blur();
                                    this.copyToClipboard(this.props.outputCode);
                                }}
                            ><Icon className="far fa-copy" style={{marginRight: '5px'}}/>Copy</Button> : <></>
                        }
                    </div>
                </div>
            </div>
            <Spacer/>
            <Spacer/>
            <Spacer/>
            <div style={{ display: 'flex' }}>
                <div style={{ flex: 1 }}>Use:</div>
            </div>
            <div style={{ display: 'flex' }}>
                <div style={{ flex: 1 }}>
                    <div style={{ position: 'relative', width: '800px' }}>
                        <pre style={{ width: '800px', padding: 0 }}>
                            <code style={{ height: '300px', overflow: 'auto', padding: '50px 20px 20px 20px' }} className={this.props.codeClass}>
                                {this.props.usageCode}
                            </code>
                        </pre>
                        {
                            this.props.usageCode ? <Button
                                style={{
                                    fontSize: '14px',
                                    color: 'white',
                                    backgroundColor: '#0b1c2c',
                                    border: 0,
                                    position: 'absolute',
                                    top: '10px',
                                    right: '25px'
                                }}
                                onClick={(e: any) => {
                                    e.target.blur();
                                    this.copyToClipboard(this.props.usageCode);
                                }}
                            ><Icon className="far fa-copy" style={{marginRight: '5px'}}/>Copy</Button> : <></>
                        }
                    </div>
                </div>
            </div>
            <Spacer/>
        </div>;
    }

}

export default CodeExample;


// WEBPACK FOOTER //
// ./src/components/model/APIDocs/CodeExample.tsx